import axios from '@/lib/axios';
import { useMutation } from '@tanstack/react-query';

interface Payload {
  email: string;
  role: UserRoles;
}

const postOtpResendMutation = async (values: Payload) => {
  const response = await axios.post('/auth/otp-resend', values);
  return response;
};

export const usePostOtpResendMutation = () => {
  return useMutation({
    mutationKey: ['otp-resend'],
    mutationFn: postOtpResendMutation,
  });
};
